import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

export const LiveScoreNotifySlice = createSlice({
    name: 'LiveScoreNotifySlice',
    initialState:{
        liveScoreMessage: {
            data: null,
            isDisplay: false
        }
    },
    reducers: {
        updateLiveScoreMessage: (state, {payload}) => {
            _.forEach(payload, (value, key) => {
                state.liveScoreMessage[key] = value;
            });
        }
    },
  });
  
  export const { updateLiveScoreMessage } = LiveScoreNotifySlice.actions;

export default LiveScoreNotifySlice.reducer;


// WEBPACK FOOTER //
// ./src/app/slices/LiveScoreNotifySlice.js